const en = {
  title: 'Current map', details: 'View details', reference: 'Reference EXP', median: 'Median',
  exact: 'Same level · Same job', allJobs: 'All jobs', nearby: 'Nearby level', accumulating: 'Building samples',
  monsters: 'Monsters', equipment: 'Equipment', scroll: 'Scrolls', more: '+{count}', moreMonsters: '+{count} species',
  population: '{count} spawns', town: 'Town', npc: '{count} NPCs', hunting: 'Hunting ground',
  idle: 'Connect a game window', pending: 'Waiting for map recognition', disabled: 'Map recognition is off',
  confirming: 'Confirming map', uncertain: 'Map not confirmed', stale: 'Last recognized', loading: 'Finding map…',
  empty: 'No matching map', error: 'Could not load map', retry: 'Retry', choose: 'Choose the current map',
  truncated: 'More matches may exist. Please confirm the map.', reselect: 'Change match',
  waitingLevel: 'Waiting for character level', efficiencyLoading: 'Finding reference…', noEfficiency: 'No reference EXP yet',
  efficiencyError: 'Reference unavailable', detailLoading: 'Loading map details…', detailError: 'Map details unavailable',
  noMonsters: 'No monsters on this map', noDrops: 'No equipment or scroll drops listed',
  source: 'Map data from 小冊子', openSource: 'Open in 小冊子', allMonsters: 'All monsters',
  samples: '{count} players · {hours} hours', updated: 'Updated {time}',
  fallback: 'No data for your job; showing all jobs in the same level range.',
  nearbyReason: 'No data in your level range; showing the nearest available range across all jobs.',
  exactReason: 'Reference for your current level range and job.',
  sampleHint: 'Samples are still accumulating. Treat this value as an early reference.',
  image: 'Minimap of {name}', open: 'View full information for {name}', unknownRate: 'Unknown rate', close: 'Close',
}
type Labels = { [K in keyof typeof en]: string }
export const currentMapMessages: Record<'zh-CN' | 'zh-TW' | 'en' | 'ja' | 'ko', Labels> = {
  en,
  'zh-CN': {
    title: '当前地图', details: '查看详情', reference: '参考经验效率', median: '中位数',
    exact: '同等级 · 同职业', allJobs: '全职业', nearby: '邻近等级', accumulating: '样本积累中',
    monsters: '怪物', equipment: '装备', scroll: '卷轴', more: '+{count}', moreMonsters: '+{count}种',
    population: '{count}只', town: '城镇', npc: '{count}位 NPC', hunting: '狩猎地图',
    idle: '连接游戏窗口后显示地图', pending: '等待识别当前地图', disabled: '地图识别已关闭',
    confirming: '正在确认地图', uncertain: '地图尚未确认', stale: '上次识别', loading: '正在查找地图…',
    empty: '暂未找到匹配地图', error: '地图加载失败', retry: '重试', choose: '请选择当前地图',
    truncated: '搜索结果较多，请确认对应地图。', reselect: '重新选择',
    waitingLevel: '识别等级后匹配效率', efficiencyLoading: '正在匹配效率…', noEfficiency: '暂无参考效率',
    efficiencyError: '效率加载失败', detailLoading: '正在加载地图资料…', detailError: '地图资料加载失败',
    noMonsters: '这张地图没有怪物', noDrops: '暂无装备或卷轴掉落资料',
    source: '地图资料来自小册子', openSource: '在小册子查看', allMonsters: '全部怪物',
    samples: '{count}人 · {hours}小时', updated: '更新于 {time}',
    fallback: '当前职业暂无数据，已使用同等级段的全部职业数据。',
    nearbyReason: '当前等级段暂无数据，已扩大至全部等级，选用距离最近的等级段与全部职业数据。',
    exactReason: '参考数据对应角色当前等级段与职业。',
    sampleHint: '样本尚在积累中，当前效率仅供初步参考。',
    image: '{name}的小地图', open: '查看{name}的完整资料', unknownRate: '概率未知', close: '关闭',
  },
  'zh-TW': {
    title: '目前地圖', details: '查看詳情', reference: '參考經驗效率', median: '中位數',
    exact: '同等級 · 同職業', allJobs: '全職業', nearby: '鄰近等級', accumulating: '樣本累積中',
    monsters: '怪物', equipment: '裝備', scroll: '卷軸', more: '+{count}', moreMonsters: '+{count}種',
    population: '{count}隻', town: '城鎮', npc: '{count}位 NPC', hunting: '狩獵地圖',
    idle: '連接遊戲視窗後顯示地圖', pending: '等待辨識目前地圖', disabled: '地圖辨識已關閉',
    confirming: '正在確認地圖', uncertain: '地圖尚未確認', stale: '上次辨識', loading: '正在尋找地圖…',
    empty: '暫未找到符合的地圖', error: '地圖載入失敗', retry: '重試', choose: '請選擇目前地圖',
    truncated: '搜尋結果較多，請確認對應地圖。', reselect: '重新選擇',
    waitingLevel: '辨識等級後比對效率', efficiencyLoading: '正在比對效率…', noEfficiency: '暫無參考效率',
    efficiencyError: '效率載入失敗', detailLoading: '正在載入地圖資料…', detailError: '地圖資料載入失敗',
    noMonsters: '這張地圖沒有怪物', noDrops: '暫無裝備或卷軸掉落資料',
    source: '地圖資料來自小冊子', openSource: '在小冊子查看', allMonsters: '全部怪物',
    samples: '{count}人 · {hours}小時', updated: '更新於 {time}',
    fallback: '目前職業暫無資料，已使用同等級區間的全部職業資料。',
    nearbyReason: '目前等級區間暫無資料，已擴大至全部等級，選用最接近的等級區間與全部職業資料。',
    exactReason: '參考資料對應角色目前等級區間與職業。',
    sampleHint: '樣本仍在累積中，目前效率僅供初步參考。',
    image: '{name}的小地圖', open: '查看{name}的完整資料', unknownRate: '機率未知', close: '關閉',
  },
  ja: {
    title: '現在のマップ', details: '詳細を見る', reference: '参考経験値効率', median: '中央値',
    exact: '同レベル帯・同職業', allJobs: '全職業', nearby: '近いレベル帯', accumulating: 'サンプル収集中',
    monsters: 'モンスター', equipment: '装備', scroll: '書', more: '+{count}', moreMonsters: '+{count}種',
    population: '{count}体', town: '街', npc: 'NPC {count}人', hunting: '狩場',
    idle: 'ゲーム画面を接続してください', pending: 'マップの認識待ち', disabled: 'マップ認識は無効です',
    confirming: 'マップ確認中', uncertain: 'マップ未確定', stale: '最後に認識したマップ', loading: 'マップ検索中…',
    empty: '一致するマップがありません', error: 'マップの読み込み失敗', retry: '再試行', choose: '現在のマップを選択',
    truncated: '候補が多いため、マップを確認してください。', reselect: '選択し直す',
    waitingLevel: 'レベル認識後に効率を検索', efficiencyLoading: '参考値を検索中…', noEfficiency: '参考効率はまだありません',
    efficiencyError: '効率の読み込み失敗', detailLoading: 'マップ情報を読み込み中…', detailError: 'マップ情報の読み込み失敗',
    noMonsters: 'このマップにモンスターはいません', noDrops: '装備・書のドロップ情報はありません',
    source: 'マップ情報：小冊子', openSource: '小冊子で見る', allMonsters: 'すべてのモンスター',
    samples: '{count}人・{hours}時間', updated: '更新：{time}',
    fallback: '現在の職業のデータがないため、同レベル帯の全職業を表示しています。',
    nearbyReason: '同レベル帯のデータがないため、全職業で最も近いレベル帯を表示しています。',
    exactReason: '現在のレベル帯と職業に対応した参考値です。',
    sampleHint: 'サンプル収集中のため、初期の参考値としてご利用ください。',
    image: '{name}のミニマップ', open: '{name}の詳細情報を見る', unknownRate: '確率不明', close: '閉じる',
  },
  ko: {
    title: '현재 지도', details: '상세 보기', reference: '참고 경험치 효율', median: '중앙값',
    exact: '같은 레벨·직업', allJobs: '모든 직업', nearby: '인접 레벨', accumulating: '표본 수집 중',
    monsters: '몬스터', equipment: '장비', scroll: '주문서', more: '+{count}', moreMonsters: '+{count}종',
    population: '{count}마리', town: '마을', npc: 'NPC {count}명', hunting: '사냥터',
    idle: '게임 창을 연결해 주세요', pending: '지도 인식 대기 중', disabled: '지도 인식이 꺼져 있습니다',
    confirming: '지도 확인 중', uncertain: '지도 미확정', stale: '마지막 인식', loading: '지도 검색 중…',
    empty: '일치하는 지도가 없습니다', error: '지도 로딩 실패', retry: '다시 시도', choose: '현재 지도를 선택하세요',
    truncated: '검색 결과가 많습니다. 지도를 확인해 주세요.', reselect: '다시 선택',
    waitingLevel: '레벨 인식 후 효율 조회', efficiencyLoading: '참고 효율 조회 중…', noEfficiency: '참고 효율이 없습니다',
    efficiencyError: '효율 로딩 실패', detailLoading: '지도 정보 로딩 중…', detailError: '지도 정보 로딩 실패',
    noMonsters: '이 지도에는 몬스터가 없습니다', noDrops: '장비 및 주문서 드롭 정보가 없습니다',
    source: '지도 자료: 小冊子', openSource: '小冊子에서 보기', allMonsters: '모든 몬스터',
    samples: '{count}명 · {hours}시간', updated: '{time} 업데이트',
    fallback: '현재 직업의 자료가 없어 같은 레벨 구간의 모든 직업 자료를 표시합니다.',
    nearbyReason: '현재 레벨 구간에 자료가 없어 모든 직업 중 가장 가까운 레벨 구간을 표시합니다.',
    exactReason: '현재 레벨 구간과 직업에 해당하는 참고 자료입니다.',
    sampleHint: '표본을 수집 중입니다. 초기 참고값으로 활용해 주세요.',
    image: '{name} 미니맵', open: '{name} 전체 정보 보기', unknownRate: '확률 미상', close: '닫기',
  },
}
